/* eslint-disable no-console */
( function ( $ ) {
	if ( $( '#get-in-touch' ).length > 0 ) {
		$( '.date-item' ).datepicker( {
			minDate: new Date(),
		} );

		const form = document.querySelector( 'form' );
		const submit = form.querySelector( 'button' );
		const inputs = document.querySelectorAll( 'input, select, textarea' );
		inputs.forEach( ( input ) => {
			input.addEventListener( 'invalid', () => {
				input.classList.add( 'error' );
			} );
			/*input.addEventListener('blur', () => {
			input.checkValidity();
			changeStateSubmit();
		});*/
			input.addEventListener( 'input', () => {
				//changeStateSubmit();
			} );
		} );
		function changeStateSubmit() {
			if ( form.checkValidity() ) {
				submit.disabled = false;
				submit.classList.remove( 'disabled' );
			} else {
				submit.classList.add( 'disabled' );
				submit.disabled = true;
			}
		}
		changeStateSubmit();
		const clearForm = () => {
			const resetButton = document.getElementById( 'btn-reset' );
			resetButton.onclick = function () {
				document.getElementById( 'get-in-touch' ).reset();
			};
		};
		clearForm();
		const formph = $( '#get-in-touch' );
		formph.validate( {
			submitHandler( formph ) {
				$( '#get-in-touch .get-in-touch_send' ).attr( 'disabled', true );
				const fd = new FormData( formph );
				formph.reset();
				$.ajax( {
					async: true,
					url: '/wp-admin/admin-ajax.php',
					type: 'POST',
					data: fd,
					cache: false,
					contentType: false,
					processData: false,
					success( data ) {
						formph.reset();
						$( '#get-in-touch .get-in-touch_send' ).attr( 'disabled', false );
						$( '.formmain__response' ).show();

						const response = JSON.parse( data );
						// console.log( response.leadId );
						window.dataLayer = window.dataLayer || [];
						dataLayer.push( {
							event: 'new_lead_created',
							leadId: response.leadId,
						} );
					},
					error( data ) {
						console.log( 'error' );
						console.log( data );
					},
				} );
				return false;
			},
			rules: {
				name_quote: {
					required: true,
				},
				phone_quote: {
					required: true,
				},
				email_quote: {
					required: true,
					email: true,
				},
			},
			messages: {
				name_quote: {
					required: 'Enter name!',
				},
				phone_quote: {
					required: 'Enter phone!',
				},
				email_quote: {
					required: 'Enter email!',
					email: 'Email must be in the correct format!',
				},
			},
			errorElement: 'div',
			focusInvalid: true,
			errorClass: 'input_error',
		} );
	}
} )( jQuery );
